export default __webpack_public_path__ + "static/media/img.f9f7107f.png";